import {FC, useState} from 'react';
import {Box, IconButton} from '@mui/material';
import {ReactComponent as Logo} from '@icons/logo.svg';
import {LOGIN} from '@/utils/constants';
import Button from '@components/Button';
import AdminDropdown from './AdminDropdown';
import {adminHeaderStyle} from './AdminHeader.styles';
import NotificationPopup from '@/layouts/OrganizationTemplate/OrganizationHeader/OrganizationNotificationPopup';
import {ROUTER_URL, USER_TYPE} from '@/utils/enums';
import {Link, useNavigate} from 'react-router-dom';
import {ReactComponent as Notification} from '@icons/notification-new.svg';
import Modal from '@/shared/components/Modal';
import LoginFormAdmin from '@/components/Admin/Login/LoginForm';
import {organizationHeaderStyle} from '@/layouts/OrganizationTemplate/OrganizationHeader/OrganizationHeader.styles';
import {LoginFormValues} from '@/components/Admin/Login/LoginForm/formConfiguration';
import {toast} from 'react-toastify';
import {getErrorMessage} from '@/utils/helpers';
import {getSuperAdminSelector, superAdminLogin} from '@/store/admin';
import {useAppDispatch} from '@/store/hooks';
import {useSelector} from 'react-redux';
import {adminStorage} from '@/utils/services';
import TwoFactorLoginForm from './TwoFactorLoginForm';

const AdminHeader: FC = () => {
  const admin = useSelector(getSuperAdminSelector);
  const userType = USER_TYPE.ADMIN;

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  // дані для другого кроку логіну (коли бекенд вимагає код 2FA)
  const [challenge, setChallenge] = useState<{challengeToken: string; expiresAt: string} | null>(null);

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleViewAllClick = () => {
    navigate(ROUTER_URL.PROFILE_NOTIFICATION);
    handleClose();
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setChallenge(null);
  };

  const finishLogin = () => {
    adminStorage.set('userType', USER_TYPE.ADMIN);
    handleCloseModal();
    navigate(ROUTER_URL.ADMIN_DASHBOARD);
  };

  const handleSubmitClickHandler = async (values: LoginFormValues) => {
    try {
      const result = await dispatch(superAdminLogin(values)).unwrap();

      if (result.requiresTwoFactor) {
        if (!result.challengeToken || !result.expiresAt) {
          toast.error('Two-step verification is unavailable. Please try again.');
          return;
        }
        setChallenge({challengeToken: result.challengeToken, expiresAt: result.expiresAt});
        return;
      }

      finishLogin();
    } catch (error) {
      toast.error(getErrorMessage(error));
    }
  };

  const open = !!anchorEl;
  const id = open ? 'simple-popover' : undefined;

  return (
    <Box sx={adminHeaderStyle.header}>
      <Box sx={adminHeaderStyle.panel}>
        <Link to="/admin">
          <Logo />
        </Link>

        {!admin && <Button sx={adminHeaderStyle.loginButton} onClick={() => setIsModalOpen(true)} title={LOGIN} />}

        {admin && (
          <Box sx={adminHeaderStyle.content}>
            <Box sx={organizationHeaderStyle.header}>
              <Box sx={organizationHeaderStyle.panel}>
                <Box sx={organizationHeaderStyle.panelInfo}>
                  <Box sx={organizationHeaderStyle.user}>
                    <IconButton
                      aria-describedby={id}
                      sx={organizationHeaderStyle.notificationButton}
                      onClick={handleClick}
                    >
                      <Notification />
                    </IconButton>

                    <NotificationPopup
                      id={id}
                      open={open}
                      anchorEl={anchorEl}
                      handleClose={handleClose}
                      handleLinkClick={handleViewAllClick}
                    />
                    <AdminDropdown />
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        )}
      </Box>

      <Modal open={isModalOpen} onClose={handleCloseModal} sx={adminHeaderStyle.modal}>
        {challenge ? (
          <TwoFactorLoginForm challenge={challenge} onVerified={finishLogin} onBack={() => setChallenge(null)} />
        ) : (
          <LoginFormAdmin handleSubmitClickHandler={handleSubmitClickHandler} userType={userType} />
        )}
      </Modal>
    </Box>
  );
};

export default AdminHeader;

// const AdminHeader: FC = () => {
// 	const admin = useSelector(getSuperAdminSelector);
// 	const userType = USER_TYPE.ADMIN;

// 	const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
// 	const [isModalOpen, setIsModalOpen] = useState(false);

// 	const navigate = useNavigate();
// 	const dispatch = useAppDispatch();
// 	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
// 		setAnchorEl(event.currentTarget);
// 	};

// 	const handleClose = () => {
// 		setAnchorEl(null);
// 	};

// 	const handleViewAllClick = () => {
// 		navigate(ROUTER_URL.PROFILE_NOTIFICATION);
// 		handleClose();
// 	};

// 	const handleSubmitClickHandler = async (values: LoginFormValues) => {
// 		try {
// 			await dispatch(superAdminLogin(values)).unwrap();
// 			adminStorage.set('userType', USER_TYPE.ADMIN);
// 			setIsModalOpen(false);
// 			navigate(ROUTER_URL.ADMIN_DASHBOARD);
// 		} catch (error) {
// 			toast.error(getErrorMessage(error));
// 		}
// 	};

// 	const open = !!anchorEl;
// 	const id = open ? 'simple-popover' : undefined;

// 	return (
// 		<Box sx={adminHeaderStyle.header}>
// 			<Box sx={adminHeaderStyle.panel}>
// 				<Link to="/admin">
// 					<Logo />
// 				</Link>

// 				{!admin && (
// 					<Button
// 						sx={adminHeaderStyle.loginButton}
// 						onClick={() => {
// 							setIsModalOpen(true);
// 						}}
// 						title={LOGIN}
// 					/>
// 				)}

// 				{admin && (
// 					<Box sx={adminHeaderStyle.content}>
// 						<Box sx={organizationHeaderStyle.header}>
// 							<Box sx={organizationHeaderStyle.panel}>
// 								<Box sx={organizationHeaderStyle.panelInfo}>
// 									<Box sx={organizationHeaderStyle.user}>
// 										<IconButton
// 											aria-describedby={id}
// 											sx={organizationHeaderStyle.notificationButton}
// 											onClick={handleClick}
// 										>
// 											<Notification />
// 										</IconButton>

// 										<NotificationPopup
// 											id={id}
// 											open={open}
// 											anchorEl={anchorEl}
// 											handleClose={handleClose}
// 											handleLinkClick={handleViewAllClick}
// 										/>
// 										<AdminDropdown />
// 									</Box>
// 								</Box>
// 							</Box>
// 						</Box>
// 					</Box>
// 				)}
// 			</Box>
// 			<Modal open={isModalOpen} onClose={() => setIsModalOpen(false)} sx={adminHeaderStyle.modal}>
// 				<LoginFormAdmin handleSubmitClickHandler={handleSubmitClickHandler} userType={userType} />
// 			</Modal>
// 		</Box>
// 	);
// };

// export default AdminHeader;
